import Footer from './Footer';
import { SocialMediaList, SocialMedia, FooterMenuList } from './types';
import { DEFAULT_SOCIAL_MEDIA_CHANNELS } from './constants';

export type { FooterMenuList, SocialMediaList, SocialMedia };
export { DEFAULT_SOCIAL_MEDIA_CHANNELS };
export default Footer;
